<p-confirmDialog key="editjob" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="ItemBorder">
	<div class="MainItemDiv">
		<label>Job Name:</label>
		<input [disabled]="IsLoading() == true" type="text" class="form-control" [(ngModel)]="JobDesc" />

		<label>Report:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="SelectedReportScript" [(ngModel)]="SelectedReportScript">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstReportScript" [ngValue]="o">{{ o.ReportScriptDesc }}</option>
		</select>

		<div class="ParameterDiv" *ngFor="let o of SelectedReportScript?.lstParameters">
			<label>{{ o.ParameterDesc }}:</label>
			<input
				*ngIf="(o.ParameterTypeID == 1 || o.ParameterTypeID == 2 || o.ParameterTypeID == 3) && o.UseList == false"
				type="text"
				class="form-control"
				[(ngModel)]="o.ParameterValue"
			/>
			<select
				*ngIf="(o.ParameterTypeID == 1 || o.ParameterTypeID == 2 || o.ParameterTypeID == 3) && o.UseList == true"
				[disabled]="IsLoading() == true"
				class="form-control"
				name="ParameterValue"
				[(ngModel)]="o.ParameterValue"
			>
				<option value="" style="display: none"></option>
				<option *ngFor="let o of o.lstOptions" [ngValue]="o.ID">{{ o.Desc }}</option>
			</select>

			<p-calendar
				*ngIf="o.ParameterTypeID == 4"
				showIcon="true"
				showButtonBar="true"
				[(ngModel)]="o.ParameterValue"
				name="ParameterDateValue"
				appendTo="body"
			></p-calendar>
			<p-calendar
				*ngIf="o.ParameterTypeID == 5"
				showTime="true"
				timeOnly="true"
				timeFormat="12"
				showIcon="true"
				showButtonBar="true"
				[(ngModel)]="o.ParameterValue"
				name="ParameterDateValue"
				appendTo="body"
			></p-calendar>
			<p-calendar
				*ngIf="o.ParameterTypeID == 6"
				[showTime]="true"
				timeFormat="12"
				showIcon="true"
				showButtonBar="true"
				[(ngModel)]="o.ParameterValue"
				name="ParameterDateValue"
				appendTo="body"
			></p-calendar>
		</div>

		<label>Active:</label>
		<input [disabled]="IsLoading() == true" type="checkbox" class="CHK" [(ngModel)]="Active" />
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button [disabled]="Processing == true" class="btn btn-warning" (click)="onClose()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
</div>
